
export default function EspecialistasHeroSection() {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-b from-purple-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
          <i className="ri-sparkling-line w-5 h-5 flex items-center justify-center"></i>
          Nossas Mentoras
        </span>
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
          Conheça as <span className="text-purple-600">Especialistas</span>
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Profissionais experientes e reconhecidas no mercado, dedicadas a guiar sua jornada de desenvolvimento e liderança feminina
        </p>
      </div>
    </section>
  );
}
